<template>
  <div>
    <el-table :data="patentData.baseInfo.lawStatusList" border style="width: 100%">
      <el-table-column prop="statusDate" label="法律公告日">
      </el-table-column>
      <el-table-column prop="label" label="法律状态">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      patentData: null
    }
  },
  created() {

  },
  mounted() {
    this.patentData = this.data;
  },
  methods: {

  }
}
</script>

<style>

</style>